<template>
  <div>
    <router-view ref="rv"/>
    <div v-show="isExactActive">
        <v-card-text>
            <v-row>
                <v-simple-table class="elevation-1" style="width: 100%">
                    <template>
                        <v-toolbar flat dense class="table-head-background">
                        <v-toolbar-title>Please Select Institute</v-toolbar-title>
                        <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template>
                        <v-card-text>
                            <center>
                                <v-row dense>
                                    <v-col cols="12" sm="12">
                                        <v-autocomplete 
                                            dense
                                            outlined
                                            prepend-inner-icon="edit"
                                            label="Please Select Institute"
                                            v-model="org" 
                                            :items="orgList"
                                            @change="saveOrg();"
                                            item-value="id"
                                            item-text="organization_name"
                                            persistent-hint
                                            :rules="[(v) => !!v || 'Compulsory']"
                                        ></v-autocomplete>
                                    </v-col>
                                </v-row>
                            </center>
                        </v-card-text>
                    </template>
                </v-simple-table>
            </v-row>
        </v-card-text>
        <div v-if="org">
            <v-row justify="center">
                <v-col  :xs="12" :sm="12" :md="8" :lg="8" :xl="6">
                    <v-text-field
                        class="centered-input"
                        v-model="search"
                        append-icon="search"
                        label="Search Masters..."
                        single-line
                        hide-details
                    ></v-text-field>
                </v-col>
            </v-row>
            <!-- <v-container fluid> -->
            <v-row dense>
                <v-col  :xs="12" :sm="3" :md="4" :lg="3"  v-for="linkname in filteredSortSearchList" :key="linkname.name" :cols="linkname.flex">
                    <router-link :to="{ name: linkname.name}" style="text-decoration: none;">
                    <v-card style="margin: 8px;" id="card-hover">
                        <br />
                        <v-img height="120px">
                        <center>
                            <v-avatar class="avatar-icon" size="70">
                            <span>
                                <v-icon size="55" class="link-icon">{{linkname.icon}}</v-icon>
                            </span>
                            </v-avatar>
                            <v-card-title v-text="linkname.textval" class="card-title"></v-card-title>
                        </center>
                        </v-img>
                        <v-card-actions>
                        <v-avatar v-if="linkname.size==0" color="red darken-1" size="22">
                            <span
                            class="white--text"
                            :title="'#'+linkname.size+' Field Added'"
                            >{{linkname.size}}</span>
                        </v-avatar>
                        <v-avatar v-else color="#4caf50" size="22">
                            <span
                            class="white--text"
                            :title="'#'+linkname.size+' Field Added'"
                            >{{linkname.size}}</span>
                        </v-avatar>
                        <v-spacer></v-spacer>

                        <router-link :to="{ name: linkname.name}" style="text-decoration: none;">
                            <v-btn icon size="22">
                            <v-icon
                                :title="'Click here to Add '+linkname.textval"
                                class="add-plus-icon"
                            >mdi-plus-circle</v-icon>
                            </v-btn>
                        </router-link>
                        </v-card-actions>
                    </v-card>
                    </router-link>
                </v-col>
            </v-row>
        </div>
    </div>
  </div> <!-- ./ root div -->
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            isExactActive:true,
            routerLinkList: [],
            search: "",
            orgList:[],
            org:"",
        };
    }, // end of data()
    methods: {
        fetchOrganization() {
            const data = {
                application_id: localStorage.getItem("loginid"),
            };
            axios
            .post("/Instructor/fetchOrgList", data)
            .then((res) => {
                if (res.data.status == "200") {
                    this.orgList = res.data.OrgList;
                } 
                else if (res.data.status == "501") {
                    this.showSnackbar("#b71c1c", res.data.msg);
                }
            })
            .catch((error) => {
                this.showSnackbar("#b71c1c", "Something went wrong.Please try again.");
            })
            .finally(() => {
                //'use strict';
            });
        },//end of function
        fetchMasterMenu() {
            this.isExactActive = typeof this.$refs.rv === 'undefined';
            axios
            .get("Master/adminMasterMenu")
            .then(res => {
                //window.console.log("res"+res.data)
                if (res.data.msg == "200") {
                this.data = res.data;
                this.routerLinkList = res.data.routerLinkList;
                //console.log(this.data)
                } 
                else {}
            })
            .catch(error => {
                //window.console.log(error);
            });
        },//end of function
        saveOrg(){
            //alert("Org >>"+this.org)
            if(this.org == null || this.org == ""){
                this.showSnackbar("#b71c1c", "Please Select Institute");
                return
            }
            else {
                localStorage.setItem("orgid", this.org);
                this.fetchMasterMenu();
            }
        },//end of function
    },
    mounted() {
        this.fetchOrganization();
    },
    updated() {
        this.isExactActive = typeof this.$refs.rv === 'undefined';
    }, // ---updated
    computed: {
        filteredSortSearchList() {
        function compare(a, b) {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        }
        if (!this.search) return this.routerLinkList.sort(compare);
        return this.routerLinkList.filter(tbdata => {
            return (
            tbdata.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
            );
        });
        }
    } // end of computed()
};
</script>
<style scoped>
.table-head-background {
  background-image: linear-gradient(-90deg, #fcc96f, #fcb63c);
  color: #fff;
  font-weight: 700;
}
.card-title {
  font-weight: 400;
  color: #9e9e9e;
}
.add-plus-icon {
  color: #616161;
}
.avatar-icon {
  border: 1px solid #0000001a;
}
.link-icon {
  color: #bdbdbd;
}
#card-hover {
  transition: cubic-bezier(0.895, 0.03, 0.685, 0.22);
}
#card-hover:hover {
  background: #ededed;
}
#card-hover:hover .link-icon {
  color: #3f51b5;
}
#card-hover:hover .avatar-icon {
  border-color: #3f51b5;
  background: white;
}
#card-hover:hover .card-title {
  color: #777777;
}
#card-hover:hover .add-plus-icon {
  border: none;
  border-radius: 100%;
  color: white;
  background: #3f51b5;
}
@media (min-width: 320px) and (max-width: 767.98px) { 
 .width-adjust{width:100% !important;;}
}
@media (min-width: 768px) and (max-width: 991.98px) {
  .width-adjust{width:80% !important;;}
}
@media (min-width: 992px) and (max-width: 1024px) { 
  .width-adjust{width: 50% !important;}
}
</style>
